import { RoutesConstants } from "./RoutesConstants"

export const MetaTags = {
    [RoutesConstants.HOME]: {
        title: "Wolf Investment - Your Partner for Smart Investment",
        description: "Welcome to Wolf Investment. Your trusted partner in financial growth.",
        keywords: "investment, financial growth, stocks, SIP calculator, IPO, Stocks, PMS, Mutual Funds, SIP, wolf investment, commodities, currency",
        author: "Wolf Investment",
        imageUrl: "/src/assets/og_default_image.jpg",
        url: "https://www.wolfinvestment.in",
        type: "website",
        twitterHandle: "@wolfinvestment",
        // Open Graph / Facebook / WhatsApp / Instagram
        og: {
            title: "Wolf Investment - Your Partner for Smart Investment",
            description: "Welcome to Wolf Investment. Your trusted partner in financial growth.",
            image: "/src/assets/og_default_image.jpg",
            url: "https://www.wolfinvestment.in",
            type: "website"
        },
        // Twitter
        twitter: {
            card: "summary_large_image",
            title: "Wolf Investment - Your Partner for Smart Investment",
            description: "Welcome to Wolf Investment. Your trusted partner in financial growth.",
            image: "/src/assets/og_default_image.jpg",
            site: "@wolfinvestment"
        },
        // LinkedIn
        linkedin: {
            title: "Wolf Investment - Your Partner for Smart Investment",
            description: "Welcome to Wolf Investment. Your trusted partner in financial growth.",
            image: "/src/assets/og_default_image.jpg",
            url: "https://www.wolfinvestment.in"
        }
    },
    [RoutesConstants.SIP_CALCULATOR]: {
        title: "SIP Calculator - Wolf Investment",
        description: "Calculate your SIP returns with our easy-to-use SIP calculator.",
        keywords: "SIP calculator, investment, financial planning, sip, returns, wolf, wolf investement",
        author: "Wolf Investment",
        imageUrl: "/src/assets/og_default_image.jpg",
        url: "https://www.wolfinvestment.in/sip-calculator",
        type: "website",
        twitterHandle: "@wolfinvestment",
        // Open Graph / Facebook / WhatsApp / Instagram
        og: {
            title: "SIP Calculator - Wolf Investment",
            description: "Calculate your SIP returns with our easy-to-use SIP calculator.",
            image: "/src/assets/og_default_image.jpg",
            url: "https://www.wolfinvestment.in/sip-calculator",
            type: "website"
        },
        // Twitter
        twitter: {
            card: "summary_large_image",
            title: "SIP Calculator - Wolf Investment",
            description: "Calculate your SIP returns with our easy-to-use SIP calculator.",
            image: "/src/assets/og_default_image.jpg",
            site: "@wolfinvestment"
        },
        // LinkedIn
        linkedin: {
            title: "SIP Calculator - Wolf Investment",
            description: "Calculate your SIP returns with our easy-to-use SIP calculator.",
            image: "/src/assets/og_default_image.jpg",
            url: "https://www.wolfinvestment.in/sip-calculator"
        }
    },
    [RoutesConstants.UNKNOWN]: { // Default meta tags for unknown routes
        title: "Page Not Found - Wolf Investment",
        description: "The page you are looking for does not exist.",
        keywords: "investment, financial growth, stocks, SIP calculator, IPO, Stocks, PMS, Mutual Funds, SIP, wolf investment, commodities, currency",
        author: "Wolf Investment",
        imageUrl: "/src/assets/og_default_image.jpg",
        url: "https://www.wolfinvesment.in/404",
        type: "website",
        og: {
            title: "Page Not Found - Wolf Investment",
            description: "The page you are looking for does not exist.",
            image: "/src/assets/og_default_image.jpg",
            url: "https://www.wolfinvesment.in/404",
            type: "website"
        },
        twitter: {
            card: "summary_large_image",
            title: "Page Not Found - Wolf Investment",
            description: "The page you are looking for does not exist.",
            image: "/src/assets/og_default_image.jpg",
            site: "@wolfinvestment"
        },
        linkedin: {
            title: "Page Not Found - Wolf Investment",
            description: "The page you are looking for does not exist.",
            image: "/src/assets/og_default_image.jpg",
            url: "https://www.wolfinvesment.in/404"
        }
    }
}

